import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      <style>{`
       .footer {
          background: #FFFFFF;
          border-top: 1px solid #E2E8F0;
          padding: 24px 30px;
          margin-top: auto;
        }
       .footer-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 16px;
        }
       .footer-left {
          display: flex;
          align-items: center;
          gap: 12px;
        }
       .footer-logo {
          width: 32px;
          height: 32px;
          background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #FFFFFF;
          font-size: 18px;
          font-weight: 800;
        }
       .footer-text {
          font-size: 14px;
          color: #64748B;
          font-weight: 500;
          margin: 0;
        }
       .footer-text strong {
          color: #0F172A;
          font-weight: 700;
        }
       .footer-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }
       .footer-link {
          font-size: 14px;
          color: #64748B;
          text-decoration: none;
          font-weight: 600;
          transition: all 0.3s ease;
        }
       .footer-link:hover {
          color: #3B82F6;
          transform: translateY(-2px);
        }
       .footer-version {
          padding: 6px 12px;
          background: #F1F5F9;
          border-radius: 6px;
          font-size: 12px;
          font-weight: 700;
          color: #475569;
        }
        @media (max-width: 768px) {
         .footer-content {
            flex-direction: column;
            text-align: center;
          }
         .footer-right {
            flex-direction: column;
            gap: 12px;
          }
        }
      `}</style>
      
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-left">
            <div className="footer-logo">S</div>
            <p className="footer-text">
              © {currentYear} <strong>Stosimo</strong>. All rights reserved.
            </p>
          </div>
          
          <div className="footer-right">
            <a href="/privacy" className="footer-link">Privacy Policy</a>
            <a href="/terms" className="footer-link">Terms of Service</a>
            <a href="/support" className="footer-link">Support</a>
            <span className="footer-version">v1.0.0</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;